export type ErrorWithCode = {
  code: string;
};

/**
 * Cognito sends back objects with a code property on it that we handle
 */
export const isObjectWithCode = (error: unknown): error is ErrorWithCode =>
  typeof error === 'object' && error !== null && 'code' in error;
